
@if (ImageLoaded) {
  <nav class="navbar" [ngClass]="{'move-down': this.setting.isAnimating, 'move-up': !this.setting.isAnimating, 'opennavbar': this.setting.openNav, 'spreadIcons': this.setting.configuration.navBarConfiguration?.autoSpreadIcons}">
    <ul class="navbar-items" [ngClass]="{'spreadIconsItems': this.setting.configuration.navBarConfiguration?.autoSpreadIcons}">






      @for (p of appPages; track p; let i = $index) {
        @if(!((p.show != undefined && !p.show(this)) || PlaceOrderStatus(p))) {
          <!--<li class="itemBarPlacement" [hidden]="(p.show != undefined && !p.show(this)) || PlaceOrderStatus(p)">-->
          <li class="itemBarPlacement">
            @if (!IsPopup(p)) {
              <a class="navItem" [routerLink]="[p.url]" (click)="optionSelect(i, p)" lines="none" detail="false" [class.selected]="selectedIndex == i && !setting.configuration.navBarConfiguration?.useCustomNavItemBackground">
              <!--<a class="navItem" (click)="navigate(p.url, i)" lines="none" detail="false">-->

                <!-- dynamic transition. use setting.configuration.navBarConfiguration?.animationEffect to check what kind of effect. Example: ease-in-out is when it shrinks and grows-->
                @if(setting.configuration.navBarConfiguration?.useCustomNavItemBackground && setting.configuration.navBarConfiguration?.customNavActiveImageShortName) {
                  <img class="imgSVG" [ngClass]="{ 'imgSVG_active': this.navbarConfigurationService.selectedNav == i }" [src]="this.customIconImage">
                  <!--
                  <svg
                    class="imgSVG"
                    [ngClass]="{ 'imgSVG_active': this.navbarConfigurationService.selectedNav == i }"
                    viewBox="0 0 110 35"
                    preserveAspectRatio="none"
                    aria-hidden="true"
                  >
                    <g
                      inkscape:label="Layer 1"
                      inkscape:groupmode="layer"
                      id="layer1"
                      style="stroke:#000000;stroke-opacity:1;fill:#000000;fill-opacity:1">
                      <g
                        id="g2"
                        transform="matrix(1.0627717,0,0,1.0892348,-2.3308061,-5.6673935)"
                        style="fill:#000000;fill-opacity:1;stroke:#000000;stroke-opacity:1">
                        <path
                          id="path1"
                          fill="currentColor"
                          style="fill-opacity:0.77108431;stroke-width:0.808735;stroke:#000000;stroke-opacity:0"
                          d="M 63.483953 5.7709875 A 31.650557 28.154278 0 0 0 40.967055 14.139436 A 6.3969494 19.681421 49.162233 0 0 38.561615 16.099302 A 6.3969494 19.681421 49.162233 0 0 27.36735 30.547555 A 6.3969494 19.681421 77.137969 0 0 15.280345 34.856792 A 16.377323 28.154278 0 0 0 1.9534217 62.518361 A 16.377323 28.154278 0 0 0 13.699085 89.523321 A 8.6446882 26.689183 85.020283 0 0 38.209576 92.494194 A 8.6446882 26.689183 85.020283 0 0 46.008899 91.446181 A 31.650557 28.154278 0 0 0 64.110719 96.505489 A 31.650557 28.154278 0 0 0 95.761189 68.350988 A 31.650557 28.154278 0 0 0 94.478482 60.417116 A 32.93866 40.66729 0 0 0 95.687766 49.500036 A 32.93866 40.66729 0 0 0 94.594208 39.107199 A 31.650557 28.154278 0 0 0 95.134909 33.925488 A 31.650557 28.154278 0 0 0 63.483953 5.7709875 z " />
                      </g>
                    </g>
                  </svg>
                  -->
                }
                

                @if (p.imagePassive) {
                  <!-- IMAGE ICON -->
                  <img [src]="p.imagePassive" class="navIcon" [ngClass]="{ 'navIcon_Enlarged': largeIcon}" alt=""/>
                } @else {
                  <!-- ION ICON (fallback) -->
                  <ion-icon class="navSvg navCompColor" [ngClass]="{ 'navSvg_Enlarged': largeIcon }" slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'" ></ion-icon>
                }

                <!--<ion-icon class="navSvg navCompColor" style="margin-bottom: 4px;" size="small" slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'" ></ion-icon>-->
                <ion-label class="navText navCompColor">{{ p.title | translate | uppercase }}
                  <!--
                  <ng-container *ngIf="p.notification > 0">
                    <ion-badge style="margin-left:2px;">{{p.notification}}</ion-badge>
                  </ng-container>
                  -->
                </ion-label>
              </a>
            }
            @if (IsPopup(p)) {
              <a class="navItem" (click)="ConfirmAndOpenModal(p, i)"  lines="none" detail="false" [class.selected]="selectedIndex == i && !setting.configuration.navBarConfiguration?.useCustomNavItemBackground">

                @if(setting.configuration.navBarConfiguration?.useCustomNavItemBackground && setting.configuration.navBarConfiguration?.customNavActiveImageShortName) {
                  <img class="imgSVG" [ngClass]="{ 'imgSVG_active': this.navbarConfigurationService.selectedNav == i }" [src]="this.customIconImage">
                  <!--
                  <svg
                    class="imgSVG"
                    [ngClass]="{ 'imgSVG_active': this.navbarConfigurationService.selectedNav == i }"
                    viewBox="0 0 110 35"
                    preserveAspectRatio="none"
                    aria-hidden="true"
                  >
                    <g
                      inkscape:label="Layer 1"
                      inkscape:groupmode="layer"
                      id="layer1"
                      style="stroke:#000000;stroke-opacity:1;fill:#000000;fill-opacity:1">
                      <g
                        id="g2"
                        transform="matrix(1.0627717,0,0,1.0892348,-2.3308061,-5.6673935)"
                        style="fill:#000000;fill-opacity:1;stroke:#000000;stroke-opacity:1">
                        <path
                          id="path1"
                          fill="currentColor"
                          style="fill-opacity:0.77108431;stroke-width:0.808735;stroke:#000000;stroke-opacity:0"
                          d="M 63.483953 5.7709875 A 31.650557 28.154278 0 0 0 40.967055 14.139436 A 6.3969494 19.681421 49.162233 0 0 38.561615 16.099302 A 6.3969494 19.681421 49.162233 0 0 27.36735 30.547555 A 6.3969494 19.681421 77.137969 0 0 15.280345 34.856792 A 16.377323 28.154278 0 0 0 1.9534217 62.518361 A 16.377323 28.154278 0 0 0 13.699085 89.523321 A 8.6446882 26.689183 85.020283 0 0 38.209576 92.494194 A 8.6446882 26.689183 85.020283 0 0 46.008899 91.446181 A 31.650557 28.154278 0 0 0 64.110719 96.505489 A 31.650557 28.154278 0 0 0 95.761189 68.350988 A 31.650557 28.154278 0 0 0 94.478482 60.417116 A 32.93866 40.66729 0 0 0 95.687766 49.500036 A 32.93866 40.66729 0 0 0 94.594208 39.107199 A 31.650557 28.154278 0 0 0 95.134909 33.925488 A 31.650557 28.154278 0 0 0 63.483953 5.7709875 z " />
                      </g>
                    </g>
                  </svg>
                  -->
                }
                

                @if (p.imagePassive) {
                  <!-- IMAGE ICON -->
                  <img [src]="p.imagePassive" class="navIcon" [ngClass]="{ 'navIcon_Enlarged': largeIcon}" alt=""/>
                } @else {
                  <!-- ION ICON (fallback) -->
                  <ion-icon class="navSvg navCompColor" [ngClass]="{ 'navSvg_Enlarged': largeIcon }" slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'" ></ion-icon>
                }

                
                <ion-label class="navText navCompColor">{{ p.title | translate | uppercase }}
                  <!--
                  <ng-container *ngIf="p.notification > 0">
                    <ion-badge style="margin-left:2px;">{{p.notification}}</ion-badge>
                  </ng-container>
                  -->
                </ion-label>
              </a>
            }
          </li>
        }
        
      }


      @if(!(auth.isAuthenticated || setting.configuration.hideMemberProgram) && !setting.configuration.navBarConfiguration?.moveLoginLogoutToSettings) {
        <li class="itemBarPlacement">

          @if (!IsPopup('Nav.Login')) {
            @if(this.setting.configuration.uIoptions?.allinOneAuthPage) {
              <a class="navItem" (click)="selectedIndex = 20" routerDirection="root" routerLink="/auth/fullauth" lines="none" detail="false" [class.selected]="selectedIndex == 20 && setting.configuration.uIoptions?.homePageOption != 10">
                <ion-icon class="navSvg navCompColor" [ngClass]="{ 'navSvg_Enlarged': largeIcon }" slot="start" ios="log-in-outline" md="log-in-sharp"></ion-icon>
                <ion-label class="navText navCompColor">{{ 'Nav.Login' | translate | uppercase }}</ion-label>
              </a>
            } @else {
              <a class="navItem" (click)="selectedIndex = 20" routerDirection="root" routerLink="/auth" lines="none" detail="false" [class.selected]="selectedIndex == 20 && setting.configuration.uIoptions?.homePageOption != 10">
                <ion-icon class="navSvg navCompColor" [ngClass]="{ 'navSvg_Enlarged': largeIcon }" slot="start" ios="log-in-outline" md="log-in-sharp"></ion-icon>
                <ion-label class="navText navCompColor">{{ 'Nav.Login' | translate | uppercase }}</ion-label>
              </a>
            }
            
          }

          @if (IsPopup('Nav.Login')) {
            <a class="navItem" (click)="OpenLoginModal()" routerDirection="root" lines="none" detail="false">
              <ion-icon class="navSvg navCompColor" [ngClass]="{ 'navSvg_Enlarged': largeIcon }" slot="start" ios="log-in-outline" md="log-in-sharp"></ion-icon>
              <ion-label class="navText navCompColor">{{ 'Nav.Login' | translate | uppercase }}</ion-label>
            </a>
          }
        </li>
      }





      <!--
      <li class="itemBarPlacement" [hidden]="auth.isAuthenticated || setting.configuration.hideMemberProgram">

        @if (!IsPopup('Nav.Login')) {
          <a class="navItem" (click)="selectedIndex = 20" routerDirection="root" routerLink="/auth" lines="none" detail="false" [class.selected]="selectedIndex == 20">
            <ion-icon class="navSvg navCompColor" style="margin-bottom: 4px;" size="small" slot="start" ios="log-in-outline" md="log-in-sharp"></ion-icon>
            <ion-label class="navText navCompColor">{{ 'Nav.Login' | translate | uppercase }}</ion-label>
          </a>
        }

        @if (IsPopup('Nav.Login')) {
          <a class="navItem" (click)="OpenLoginModal()" routerDirection="root" lines="none" detail="false">
            <ion-icon class="navSvg navCompColor" style="margin-bottom: 4px;" size="small" slot="start" ios="log-in-outline" md="log-in-sharp"></ion-icon>
            <ion-label class="navText navCompColor">{{ 'Nav.Login' | translate | uppercase }}</ion-label>
          </a>
        }
      </li>
      -->







      @if(auth.isAuthenticated && !setting.configuration.navBarConfiguration?.moveLoginLogoutToSettings) {
        <li class="itemBarPlacement">

          <a class="navItem" (click)="logout()" lines="none" detail="false">
            <ion-icon class="navSvg navCompColor" [ngClass]="{ 'navSvg_Enlarged': largeIcon }" slot="start" ios="log-out-outline" md="log-out-sharp"></ion-icon>
            <ion-label class="navText navCompColor" >{{ 'Nav.Logout' | translate | uppercase }}</ion-label>
          </a>
        </li>
      }

      





      <!--
      <li class="itemBarPlacement" [hidden]="!auth.isAuthenticated">

        <a class="navItem" (click)="logout()" lines="none" detail="false">
          <ion-icon class="navSvg navCompColor" size="small" slot="start" ios="log-out-outline" md="log-out-sharp"></ion-icon>
          <ion-label class="navText navCompColor" >{{ 'Nav.Logout' | translate | uppercase }}</ion-label>
        </a>
      </li>
      -->

      <!--
      <li class="itemBarPlacement">

        <div class="langDisplay" *ngIf="supportedLanguages && supportedLanguages.length > 0">
          <a class="langText langTextFont" *ngFor="let language of supportedLanguages" (click)="changeLang(language.name)" >{{language.name | uppercase}}</a>
        </div>

        <div class="langDisplay" *ngIf="!supportedLanguages || supportedLanguages.length == 0">
          <a class="langText langTextFont centeredLang" (click)="changeLang('fr')" >FR</a>
          <a class="langText langTextFont centeredLang" (click)="changeLang('en')" >EN</a>

        </div>

      </li>
      -->

    </ul>

    
    @if(!this.setting.configuration.navBarConfiguration?.disableNavbarLanguage) {
      <div class="languageContainer" [ngClass]="{'languageContainer_ext': this.setting.configuration.navBarConfiguration?.autoSpreadIcons}">
        @if (supportedLanguages && supportedLanguages.length > 0) {
          <div class="langDisplay">
            <!--I'll try to keep track of this one-->
            @for (language of supportedLanguages; track language) {
              <a class="langText langTextFont navCompColor" (click)="changeLang(language.name)" >{{language.name | uppercase}}</a>
            }
            <!--<p class="langTextFont formatedText" style="color: white;">&nbsp;/&nbsp;</p>-->
          </div>
        }

        @if (!supportedLanguages || supportedLanguages.length == 0) {
          <div class="langDisplay">
            @if (currentLanguages == 'en') {
              <a class="langText langTextFont centeredLang navCompColor" (click)="changeLang('fr')" >FR</a>
            }
            <!--<p class="langTextFont formatedText" style="color: white;">&nbsp;/&nbsp;</p>-->
            @if (currentLanguages == 'fr') {
              <a class="langText langTextFont centeredLang navCompColor" (click)="changeLang('en')" >EN</a>
            }
          </div>
        }
      </div>
    }
    


    <!-- add the hamburger menu here -->
    @if(!setting.configuration.navBarConfiguration?.disableExpension) {
      <div class="showMoreOptions">
        <ion-icon #menuIcon class="toggleButton navCompColor" [ngClass]="{ 'toggleButton_Enlarged': largeIcon }" slot="end" (click)="this.setting.toggleShowMore()" [name]="applyExpandIcon()" ></ion-icon>
      </div>


      @if (verifySize()) {
        <div class="closeMenuButton" [ngClass]="{'changeButtonPosition': this.setting.isAnimating }">
          <ion-icon #menuIcon class="toggleButton navCompColor" [ngClass]="{ 'toggleButton_Enlarged': largeIcon }" slot="end" (click)="this.setting.toggle()" name="menu"></ion-icon>
        </div>
      }
    }
    

  </nav>
}
